import { arc } from 'd3-shape';

/**
 * Convenience method to build a d3 arc
 *
 * The `d` attribute of the SVG path element expects a string | undefined
 * while the arc returns string | null. This method converts nulls to undefined
 *
 * @param innerRadius - Arc inner radius
 * @param outerRadius - Arc outer radius
 * @param startAngle - Arc start angle
 * @param endAngle - Arc end angle
 */
export const buildArc = (
  innerRadius: number,
  outerRadius: number,
  startAngle: number,
  endAngle: number,
) => {
  const d3Arc = arc();
  return (
    d3Arc({
      innerRadius,
      outerRadius,
      startAngle,
      endAngle,
    }) ?? undefined
  );
};
